export default __webpack_public_path__ + "static/sn-501b6a8ab21c318b28ce4eab7c35485b.svg";